import { Link } from "react-router-dom";

import { useStyles } from "./ButtonLink.style";

export interface ButtonLinkProps {
  text: string;
  to: string;
  textColor?: string;
  background?: string;
}

export const ButtonLink = (props: ButtonLinkProps) => {
  const classes = useStyles(props);
  const { text, to } = props;

  return (
    <Link to={to} className={classes.root}>
      {text}
    </Link>
  );
};
